import { Box, Chip, Typography } from '@material-ui/core'
import OutlinedButton from '../OutlinedButton'
import StatusButton from '../StatusButton'
import history from '../../routes/history'
import {
  SUBMIT_NEW_APPLICATION,
  EDIT_APPLICATION,
  DOWNLOAD_APPLICATION_FORM,
  SEE_APPLICATION_WORKFLOW,
} from './constants'
import { headerStyles } from './style'
import DownloadFile from '../../Services/DownloadFile'
import moment from 'moment-timezone'
import { defaultTimezone, timeZoneAbbrs } from '../../utils/momentTimezones'
import ScheduleIcon from '@material-ui/icons/Schedule'

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

const PageTitleInstaller = (props) => {
  const dropDownOptions = [
    {
      key: 'submitted',
      value: 'Submitted For Review',
      color: '#CFC338',
    },
    {
      key: 'rejected',
      value: 'Rejected',
      color: '#FF6565',
    },
    {
      key: 'approved',
      value: 'Approved',
      color: '#35C37D',
    },
    {
      key: 'unenrolled',
      value: 'Unenrolled',
      color: '#CBCBCB',
    }
  ]
  const classes = headerStyles()
  const {
    heading,
    hasNewApplicationButton,
    hasEditApplicationButton,
    hasDownloadApplicationFormButton,
    status,
    site,
  } = props

  return (
    <Box className={classes.programHeaderBar}>
      <Box
        className={
          status === undefined &&
            hasNewApplicationButton === undefined &&
            hasEditApplicationButton === undefined
            ? classes.programDetailsDynamicEditRejectedApplication
            : status && status === 'rejected' && hasEditApplicationButton
              ? classes.programDetailsDynamicRejectedApplication
              : classes.programDetailsDynamicInstallerHomePage
        }
      >
        <Typography className={classes.programTitle}>{heading}</Typography>
      </Box>
      {status ? (
        status === 'approved' ? (
          <StatusButton color="#35C37D" text="Approved by Enphase"></StatusButton>
        ) : status === 'rejected' ? (
          <StatusButton color="#FF6565" text="Rejected by Enphase"></StatusButton>
        ) : status === 'submitted' ? (
          <StatusButton color="#CFC338" text="Submitted for Enphase Review"></StatusButton>
        ) : status === 'report_generated' ? (
          <StatusButton color="#026AE3" text="Evidence report mailed"></StatusButton>
        ) : status === 'unenrolled' ? (
          <StatusButton color='#CBCBCB' text="Unenrolled"></StatusButton>
        ) : null
      ) : null}
      {status && site && site.last_modified_date ? (
        status === 'approved' ? (
          <Box ml={1}>
            <Chip size="small" avatar={<ScheduleIcon style={{ color: "#7F7F7F" }} />} label={`Approved on ${moment.tz(site.last_modified_date, defaultTimezone).format('MMMM DD, YYYY hh:mm A zz')}`} variant="outlined" />
          </Box>
        ) : status === 'rejected' ? (
          <Box ml={1}>
            <Chip size="small" avatar={<ScheduleIcon style={{ color: "#7F7F7F" }} />} label={`Rejected on ${moment.tz(site.last_modified_date, defaultTimezone).format('MMMM DD, YYYY hh:mm A zz')}`} variant="outlined" />
          </Box>
        ) : status === 'submitted' ? (
          <Box ml={1}>
            <Chip size="small" avatar={<ScheduleIcon style={{ color: "#7F7F7F" }} />} label={`Submitted on ${moment.tz(site.last_modified_date, defaultTimezone).format('MMMM DD, YYYY hh:mm A zz')}`} variant="outlined" />
          </Box>
        ) : status === 'report_generated' ? (
          <Box ml={1}>
            <Chip size="small" avatar={<ScheduleIcon style={{ color: "#7F7F7F" }} />} label={`Mailed on ${moment.tz(site.last_modified_date, defaultTimezone).format('MMMM DD, YYYY hh:mm A zz')}`} variant="outlined" />
          </Box>
        ) : status === 'unenrolled' ? (
          <Box ml={1}>
            <Chip size="small" avatar={<ScheduleIcon style={{ color: "#7F7F7F" }} />} label={`Unenrolled on ${moment.tz(site.last_modified_date, defaultTimezone).format('MMMM DD, YYYY hh:mm A zz')}`} variant="outlined" />
          </Box>
        ) : null
      ) : null}

      {hasNewApplicationButton && !hasDownloadApplicationFormButton && (
        <Box className={classes.programDetailsStatic}>
          <Box className={classes.staticMargin}>
            <OutlinedButton
              label={SUBMIT_NEW_APPLICATION}
              width="auto"
              height="auto"
              onClick={() => {
                history.push('/application')
              }}
            ></OutlinedButton>
          </Box>
        </Box>
      )}
      {hasNewApplicationButton && hasDownloadApplicationFormButton && (
        <Box className={classes.programDetailsStatic}>
          <Box className={classes.staticMargin}>
            <OutlinedButton
              label={SUBMIT_NEW_APPLICATION}
              width="auto"
              height="auto"
              onClick={() => {
                history.push('/application')
              }}
            ></OutlinedButton>
          </Box>
          <Box className={classes.staticMargin}>
            <OutlinedButton
              label={DOWNLOAD_APPLICATION_FORM}
              width="auto"
              height="auto"
              onClick={() => {
                DownloadFile(process.env.PUBLIC_URL + '/HECOSDP_Forms.zip')
              }}
            ></OutlinedButton>
          </Box>
          <Box className={classes.staticMargin}>
            <OutlinedButton
              label={SEE_APPLICATION_WORKFLOW}
              width="auto"
              height="auto"
              onClick={() => {
                props && props.setWorkflowModal && props.setWorkflowModal(true)
              }}
            ></OutlinedButton>
          </Box>
        </Box>
      )}
      {!hasNewApplicationButton && hasDownloadApplicationFormButton && (
        <Box className={classes.programDetailsStatic}>
          <Box className={classes.staticMargin}>
            <OutlinedButton
              label={DOWNLOAD_APPLICATION_FORM}
              width="auto"
              height="auto"
              onClick={() => {
                DownloadFile(process.env.PUBLIC_URL + '/HECOSDP_Forms.zip')
              }}
            ></OutlinedButton>
          </Box>
        </Box>
      )}
      {hasEditApplicationButton && (
        <Box className={classes.programDetailsStatic}>
          <Box className={classes.staticMargin}>
            <OutlinedButton
              label={EDIT_APPLICATION}
              width="auto"
              height="auto"
              onClick={() => {
                history.push({
                  pathname: '/application',
                  state: { site: site },
                })
              }}
            ></OutlinedButton>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default PageTitleInstaller
